<template>
  <star-rating :star-size="25" :read-only="disabled" :rating="value" @rating-selected="$emit('input', $event); $emit('answered');" :show-rating="false" activeColor="#009688"/>
</template>

<script>
  export default {
    name: "z-number",
    props: {
      value: {
        type: Number
      },
      disabled: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style scoped>
  .vue-star-rating {
    justify-content: space-around;
  }
</style>